module.exports = __webpack_public_path__ + "static/media/coursemix.5b0c04e9.png";